import { connect } from 'react-redux';
import { Dispatch } from 'react-redux';
import { deleteConfirmation, loggingAllowed, tooltips } from 'src/constants/profileSettings';
import { IState } from 'src/store/reducer';
import { loadProfileSettings ,switchAppLanguage, switchEditTheme, switchEditView, switchGenView, switchLoggingFlag, switchTooltipsSettings, toggleDeleteConf } from '../../store/actions';
import ProfileComponent from './ProfileComponent';

const mapStateToProps = (state: IState) => {
  return {
    generators: state.gen.generators,
    profile: state.user.profile
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    reloadProfile: () => loadProfileSettings(dispatch),
    switchAppLanguage: (language: string) => switchAppLanguage(dispatch, language),
    switchEditTheme: (theme: string) => switchEditTheme(dispatch, theme),
    switchEditView: (view: string) => switchEditView(dispatch, view),
    switchGenView: (view: string) => switchGenView(dispatch, view),
    switchLogging: (setting: loggingAllowed) => switchLoggingFlag(dispatch, setting),
    switchTooltipsSettings: (setting: tooltips) => switchTooltipsSettings(dispatch, setting),
    toggleDelConf: (bool: deleteConfirmation) => toggleDeleteConf(dispatch, bool),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileComponent)



// WEBPACK FOOTER //
// ./src/Containers/Profile/index.tsx